import {autoserializeAs, autoserializeAsArray} from "dcerialize";
import {Tag} from "../Tag";
import {FeaturedDetails} from "./FeaturedDetails";
import {ReferenceCustomer} from "./ReferenceCustomer";
import {ReferenceDetails} from "./ReferenceDetails";
import {ReferenceImages} from "./ReferenceImages";
import {ReferenceLink} from "./ReferenceLink";
import {ReferenceTechnology} from "./ReferenceTechnology";

export enum ReferenceKind {
  Product = "product",
  Project = "project",
}

export class Reference {
  @autoserializeAs(() => Number)
  public readonly id: number;
  @autoserializeAs(() => String)
  public readonly name: string;
  @autoserializeAs(() => String)
  public readonly slug: string;
  @autoserializeAs(() => String)
  public readonly summary: string;
  @autoserializeAs(() => FeaturedDetails)
  public readonly featuredDetails?: FeaturedDetails;
  @autoserializeAs(() => ReferenceCustomer)
  public readonly customer: ReferenceCustomer;
  @autoserializeAs(() => ReferenceImages)
  public readonly images?: ReferenceImages;
  @autoserializeAsArray(() => ReferenceTechnology)
  public readonly technologies: readonly ReferenceTechnology[];
  @autoserializeAs(() => String)
  public readonly kind: ReferenceKind;
  @autoserializeAs(() => ReferenceDetails)
  public readonly details?: ReferenceDetails;
  @autoserializeAsArray(() => ReferenceLink)
  public readonly links: readonly ReferenceLink[];
  @autoserializeAsArray(() => Tag)
  public readonly tags: readonly Tag[];
  @autoserializeAs(() => Date)
  public readonly createdAt: Date;
  @autoserializeAs(() => Date)
  public readonly updatedAt?: Date;

  public get technologyNames(): readonly string[] {
    return this.technologies.map(technology => technology.name);
  }
}

export type FeaturedReference = Reference & { readonly featuredDetails: FeaturedDetails };
